import React, { useState } from "react";
import { Box, Toolbar, useMediaQuery } from "@mui/material";
import TopBar from "./TopBar";
import SideNav from "./SideDrawer";
import { useTheme } from '@mui/material/styles';
const DRAWER_WIDTH = 260;
const Layout = ({ children }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);
  const toggleDrawer = () => setOpen(!open);
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const isExpanded = isLargeScreen && open;

  return (
    <Box sx={{ display: 'flex' }}>
      <TopBar open={open} isExpanded={isExpanded} onDrawerToggle={toggleDrawer} />
      <SideNav isExpanded={isExpanded}/>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          minHeight: '100vh',
          bgcolor: theme.palette.background.layout,
          width: { sm: `calc(100% - ${DRAWER_WIDTH}px)` },
          overflowX: 'hidden',
        }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
};

export default Layout;